import styles from './PSD2ConnectionPendingPage.module.css';
import { Card } from '../../../../../organisms/card';
import SkeletonComponent from '../../../../../../components/SkeletonComponent';
import Divider from '../../../../../atoms/divider';
import Text from '../../../../../atoms/typography/Text';
import { ColorEnum, FontSizeEnum, FontWeightEnum } from '../../../../../enums';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useRoutePath } from '../../../../../utils/useRoutePath';
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import bankAccountAgreementIsSigned from '../../../../../../api/screening/income-verification/bank-account-agreement-is-signed/bankAccountAgreementIsSigned';
import PageContentNotFound from '../../../../../organisms/page-content-not-found/PageContentNotFound';

const PSD2ConnectionPendingPage = () => {
    const {t} = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const routePath = useRoutePath();
    const {homeseekerId} = useParams();
    const [ searchParams ] = useSearchParams();

    const authorisationId = searchParams.get('authorisationId');

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const reference = queryParams.get('ref');
        const error = queryParams.get('error');

        setTimeout(() => {
            if (reference && !error) {
                const goCardlessAgreementId = localStorage.getItem('goCardlessAgreementId');

                if (goCardlessAgreementId === null || goCardlessAgreementId === undefined) {
                    navigate(routePath('ScreeningIncomeVerificationProvideTransactionsPsd2ConnectionFailedPage', { homeseekerId }, { authorisationId }), {replace: true});
                }

                bankAccountAgreementIsSigned(homeseekerId, goCardlessAgreementId)
                    .then(() => {
                        localStorage.removeItem('goCardlessAgreementId')
                        navigate(routePath('ScreeningIncomeVerificationProvideTransactionsPsd2ConnectionSuccessPage', { homeseekerId }, { authorisationId }), {replace: true});
                    })
                    .catch(() => {
                        navigate(routePath('ScreeningIncomeVerificationProvideTransactionsPsd2ConnectionFailedPage', { homeseekerId }, { authorisationId }), {replace: true});
                    });
            } else {
                navigate(routePath('ScreeningIncomeVerificationProvideTransactionsPsd2ConnectionFailedPage', { homeseekerId }, { authorisationId }), {replace: true});
            }
        }, 1000);
    }, []);

    if (!authorisationId) {
        return <PageContentNotFound/>;
    }

    return (
        <div className={styles.contentContainer}>
            <div className={styles.gridLg}>
                <Text
                    color={ColorEnum.Primary700}
                    weight={FontWeightEnum.Bold}
                    size={FontSizeEnum.DisplayXs}
                >{t('screening.incomeVerification.provideTransactions.page.title')}</Text>
                <Card elevated>
                    <div className={styles.gridMd}>
                        <div className={styles.skeletonContainer}>
                            <SkeletonComponent width={40} height={40}/>
                            <SkeletonComponent width={200} height={24}/>
                            <Divider/>
                            <SkeletonComponent count={4} width={311} height={8}/>
                        </div>
                    </div>
                </Card>
            </div>
        </div>
    );
}

export default PSD2ConnectionPendingPage;
